module.exports = __webpack_public_path__ + "static/media/header.cd74f3cb.jpg";